export default __webpack_public_path__ + "static/media/consent.26328658.pdf";